import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle } from '@scio3/ui';

interface WistiaDialogProps {
  videoId: string | null;
  onClose: () => void;
}

/**
 * Wistia video dialog that displays a video in a modal overlay.
 * Used by GetStartedChecklist for the "getting started" video.
 */
export function WistiaDialog({ videoId, onClose }: WistiaDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={!!videoId} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl pt-10" aria-describedby={undefined}>
        <DialogTitle className="sr-only">{t('getStarted.watchVideo')}</DialogTitle>
        {videoId && (
          <iframe
            src={`https://fast.wistia.com/embed/iframe/${videoId}?autoplay=1`}
            className="aspect-video w-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            title={t('getStarted.watchVideo')}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
